import "../App.css";
import tyreStackIcon from "../images/tyre-stack-icon.png"
import lorryIcon from "../images/lorry-icon.png"
import garageIcon from "../images/garage-icon.png"

function Features() {
  return (
    <>
    {/* <h1 className="pt-10 bg-white text-3xl text-center font-rescue text-zinc-600">Our Services</h1> */}
    <div class="bg-white py-12 sm:py-16 font-rescue text-rescueRed">
      <div class="mx-auto max-w-7xl px-6 lg:px-8">
        <dl class="grid grid-cols-1 gap-x-8 gap-y-16 text-center lg:grid-cols-3">
          <div class="mx-auto flex items-center max-w-xs flex-col gap-y-4">
            <img src={tyreStackIcon} width={100} alt="tyre stack icon" />
            <p>Find Your Perfect Fit</p>
          </div>
          <div class="mx-auto flex items-center max-w-xs flex-col gap-y-4">
          <img src={lorryIcon} width={100} alt="tyre stack icon" />
          <p>Your Chosen Tyres Sourced</p>
          </div>
          <div class="mx-auto flex items-center max-w-xs flex-col gap-y-4">
          <img src={garageIcon} width={100} alt="tyre stack icon" />
          <p>Balancing, Alignment & Brakes</p>
          </div>
        </dl>
      </div>
    </div>
    </>
  );
}

export default Features;
